import script from "./projectCase.vue?vue&type=script&setup=true&lang=js"
export * from "./projectCase.vue?vue&type=script&setup=true&lang=js"

import "./projectCase.vue?vue&type=style&index=0&id=149be6d2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149be6d2"]])

export default __exports__